import NameSection from './NameSection';
import CriteriaSection from './CriteriaSection';
import FormatSection from './FormatSection';
import TableSetupSection from './TableSetupSection';
import Actions from './Actions/index';

export {
  NameSection,
  CriteriaSection,
  FormatSection,
  TableSetupSection,
  Actions,
};



// WEBPACK FOOTER //
// ./src/views/ReportFilters/components/index.js